module.exports = __webpack_public_path__ + "img/needs-blue.5e5ac727.svg";